export const CSS_WIDE_KEYWORDS = new Set([
    'inherit',
    'initial',
    'unset',
    'revert',
    'revert-layer',
]);
export function isCssWideKeyword(value) {
    return CSS_WIDE_KEYWORDS.has(value);
}
//# sourceMappingURL=css-wide-keywords.js.map